var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.375C5.51269 2.375 1.875 6.01269 1.875 10.5C1.875 14.9874 5.51269 18.625 10 18.625C14.4874 18.625 18.125 14.9874 18.125 10.5C18.125 6.01269 14.4874 2.375 10 2.375ZM0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5229 0.5 20 4.97715 20 10.5C20 16.0229 15.5229 20.5 10 20.5C4.47715 20.5 0 16.0229 0 10.5ZM8.125 10.1875C8.125 9.66974 8.54474 9.25 9.0625 9.25H10.3125C10.8303 9.25 11.25 9.66974 11.25 10.1875V13.625H11.5625C12.0803 13.625 12.5 14.0448 12.5 14.5625C12.5 15.0802 12.0803 15.5 11.5625 15.5H9.0625C8.54474 15.5 8.125 15.0802 8.125 14.5625C8.125 14.0448 8.54474 13.625 9.0625 13.625H9.375V11.125H9.0625C8.54474 11.125 8.125 10.7053 8.125 10.1875ZM10 8C10.6904 8 11.25 7.44035 11.25 6.75C11.25 6.05965 10.6904 5.5 10 5.5C9.30965 5.5 8.75 6.05965 8.75 6.75C8.75 7.44035 9.30965 8 10 8Z",
    fill: "#298CF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.deb1fc1d3840f0a026eced4aa33cc9e2.svg";
export { ForwardRef as ReactComponent };